<div class="mt-2 mb-2">
  <mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState()" (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header class="borderBottom">
        <mat-panel-title><span class="title">Relazioni</span></mat-panel-title>
        <mat-panel-description class="justify-content-end">
          @if (!saved) {
<i class="bi bi-exclamation-circle-fill" style="color: red; font-size: large;"></i>
}
          @if (saved) {
<i class="bi bi-check-circle-fill" style="color: green; font-size: large;"></i>
}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid p-1 p-lg-2">
        <form [formGroup]="relationsForm">

          <div formArrayName="relations" class="row pb-2 mt-2">
            <label class="form-label" style="font-weight: bold;">
              Relazioni
            </label>
            @for (item of relations.controls; track item; let i = $index) {
<div [formGroupName]="i"
              class="col-12 col-md-6 col-lg-4 mt-1">
              <div class="input-group" style="height: 40px;">
                <input type="text" class="form-control" placeholder="" id="relation-{{i}}" formControlName="relation"
                  [class.is-invalid]="item.get('relation')?.invalid && (submitted || item.get('relation')?.dirty)">
                @if (i != 0) {
<button type="button" class="btn btn-danger" (click)="removeRelations(i)">
                  <i class="bi bi-trash"></i>
                </button>
}
              </div>
              @if (item.get('relation')?.errors?.['maxlength'] && item.get('relation')?.dirty) {
<div>
                <span style="font-size: x-small; color: red;">Max 25 caratteri</span>
              </div>
}
            </div>
}

            <div class="col-12 mt-2">
              <button class="btn btn-outline-dark" style="max-width: 300px;" (click)="addRelations()">
                Aggiungi Relazioni
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>


        </form>

        <div class="row justify-content-center mt-4 borderTop">
          @if (relationsForm.invalid && submitted) {
<div class="col-12 mt-2 text-center">
            <small>Compilare correttamente tutti i campi obbligatori per abilitare il
              salvataggio
            </small>
          </div>
}
          <div class="col-12 col-md-6 col-lg-4 mt-1 text-center">
            <button class="btn btn-outline-dark" (click)="save()">Salva</button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
